import { MutationTree } from "vuex"
import { WidgetState } from "@/apps/StudentExchangeProgressColumnWidget/models/store-viewmodel"
import { ILabels } from "@/apps/StudentExchangeProgressColumnWidget/models/config-viewmodel"

export default <MutationTree<WidgetState>>{
    labels(state, labels: ILabels) {
        state.labels = labels
    },
    progressLabels(state, progressLabels: []) {
        state.progressLabels = progressLabels
    }
}
